import React, { useState, useEffect } from "react";
import { NamedPsrCaptureProfile } from "../../../Model/CaptureProfile";
import { PsrCameraCapabilities } from "../../../Model/PsrCapabilites";
import AccordionToggle from "../../Plate/AccordionToggle";
import Collapse from "../../Common/Collapse";
import Disabled from "../../Controls/Disabled";
import CommonDropDown from "../../Common/DropDown/CommonDropDown";
import { useConfirm } from "../../Hooks/WindowHooks";
import TabPanel from "../../PlateTypeEditor/TabPanel";
import RaspiCameraConfigurator from "./RaspiCameraConfigurator";
import PsrCameraManualControl from "../Control/PsrCameraManualControl";
import { PSR_CAMERA_MANUAL_ACCORDION_STATE } from "../Control/PsrCameraManualControl";

function getInitialChevronButtonDegree(key: string): number {
  const value = localStorage.getItem(key);
  if (value != null) {
    const objVal = JSON.parse(value) as boolean[];
    if (objVal.every((val) => val)) {
      return 180;
    }
    return 0;
  } else {
    return 0;
  }
}

type Props = {
  psrCameraId: number;
  psrIdentifier: string;
  psrCaptureProfiles: NamedPsrCaptureProfile[];
  psrCaptureProfile: NamedPsrCaptureProfile;
  setPsrCaptureProfile: (cp: NamedPsrCaptureProfile) => void;
  psrCameraCapabilities: PsrCameraCapabilities;
  isPsrCaptureProfileConfigUpdated: boolean;
  setIsPsrCaptureProfileConfigUpdated: (
    isPsrCaptureProfileConfigUpdated: boolean
  ) => void;
};

export default function RaspiCameraSettings({
  psrCameraId,
  psrIdentifier,
  psrCaptureProfiles,
  psrCaptureProfile,
  setPsrCaptureProfile,
  psrCameraCapabilities,
  isPsrCaptureProfileConfigUpdated,
  setIsPsrCaptureProfileConfigUpdated,
}: Props) {
  const [triggerExpandSetting, setTriggerExpandSetting] = useState(false);
  const [chevronButtonDegree, setChevronButtonDegree] = useState(
    getInitialChevronButtonDegree(PSR_CAMERA_MANUAL_ACCORDION_STATE)
  );

  const onAllChildrenCollapsed = (collapsed: boolean) => {
    if (collapsed) {
      setChevronButtonDegree(0);
    } else {
      setChevronButtonDegree(180);
    }
  };

  return (
    <div
      style={{
        backgroundColor: "white",
        height: "100%",
        overflow: "auto",
        fontSize: 14,
      }}
    >
      <TabPanel
        id="psr-camera-config"
        collapsible={false}
        disabled={false}
        allowChange={true}
        activeTabStyle={{ padding: 0 }}
        chevronButton="double"
        onTriggerExpand={() => setTriggerExpandSetting(true)}
        chevronButtondegree={chevronButtonDegree}
      >
        {{
          Configuration: (
            <RaspiCameraConfigurator
              psrCaptureProfile={psrCaptureProfile}
              psrCaptureProfiles={psrCaptureProfiles}
              psrCameraCapabilities={psrCameraCapabilities}
              setPsrCaptureProfile={setPsrCaptureProfile}
              isPsrCaptureProfileConfigUpdated={
                isPsrCaptureProfileConfigUpdated
              }
              setIsPsrCaptureProfileConfigUpdated={
                setIsPsrCaptureProfileConfigUpdated
              }
            />
          ),
          "Control Panel": (
            <PsrCameraManualControl
              disabled={false}
              headerEnabled={false}
              psrCameraId={psrCameraId}
              psrIdentifier={psrIdentifier}
              triggerExpandAll={triggerExpandSetting}
              setTriggerExpandAll={setTriggerExpandSetting}
              onAllItemCollapsed={onAllChildrenCollapsed}
            />
          ),
        }}
      </TabPanel>
    </div>
  );
}
